/** Small stroke icons for sidebar — 20×20 viewBox */
export function IconProducts(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <path
        d="M3.5 6.5h13v9a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-9Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 6.5V4.75a2.25 2.25 0 0 1 2.25-2.25h2.5A2.25 2.25 0 0 1 13.5 4.75V6.5"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M7 10h6" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function IconStock(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <path
        d="M4 7.5 10 3.5l6 4v8.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5V9.5h4v3"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconPOS(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <rect
        x="3"
        y="4.5"
        width="14"
        height="11"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M6.5 14.5h7M8 11.5h4"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <circle cx="6.25" cy="8.75" r=".9" fill="currentColor" />
      <circle cx="10" cy="8.75" r=".9" fill="currentColor" />
      <circle cx="13.75" cy="8.75" r=".9" fill="currentColor" />
    </svg>
  );
}

export function IconReports(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <path
        d="M5.5 3.5h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M7 7.5h6M7 10.5h6M7 13.5h4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function IconExpense(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <rect
        x="3.5"
        y="4"
        width="13"
        height="12"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M6.5 8h7M6.5 11h4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M12.5 14.5h3M14 13v3"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconUsers(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <circle cx="10" cy="6.25" r="2.75" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M4.75 16.25v-1.1a3.25 3.25 0 0 1 3.25-3.25h4a3.25 3.25 0 0 1 3.25 3.25v1.1"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}
